export default __webpack_public_path__ + "./fonts/pencil.0ab65af1.svg";